import {
  BLOG_CATEGORY_PAGE,
  BLOG_HOME_PAGE,
  BLOG_PAGE,
  FACILITIES_LIST_PAGE,
  FACILITY_LINK,
  FACILITY_LISTING,
  FACILITY_PAGE,
  HOME_PAGE,
  MISC_PAGE,
  PAY_ONLINE_PAGE,
  PRIVACY_PAGE,
  TERMS_PAGE,
} from '../../../src/shared/pageTypes';

export const BASIC_SITE = 'voyager/sites/types/BASIC';

export {
  BLOG_CATEGORY_PAGE,
  BLOG_HOME_PAGE,
  BLOG_PAGE,
  FACILITIES_LIST_PAGE,
  FACILITY_LINK,
  FACILITY_LISTING,
  FACILITY_PAGE,
  HOME_PAGE,
  MISC_PAGE,
  PAY_ONLINE_PAGE,
  PRIVACY_PAGE,
  TERMS_PAGE,
};

export const BASE_PAGE_TYPE_CODES = [
  FACILITIES_LIST_PAGE,
  FACILITY_LINK,
  FACILITY_LISTING,
  FACILITY_PAGE,
  HOME_PAGE,
  MISC_PAGE,
  PAY_ONLINE_PAGE,
  PRIVACY_PAGE,
  TERMS_PAGE,
];

export const BLOG_PAGE_TYPE_CODES = [
  BLOG_CATEGORY_PAGE,
  BLOG_HOME_PAGE,
  BLOG_PAGE,
];

export const PAGE_TYPES = [
  ...BASE_PAGE_TYPE_CODES,
  ...BLOG_PAGE_TYPE_CODES,
];
